import { render, staticRenderFns } from "./wronglyDeliveredClearance.vue?vue&type=template&id=16537d2e&"
import script from "./wronglyDeliveredClearance.vue?vue&type=script&lang=js&"
export * from "./wronglyDeliveredClearance.vue?vue&type=script&lang=js&"
import style0 from "./wronglyDeliveredClearance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports